import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { DENSITY } from './Divider.types';

export const $Divider = styled.div`
  width: 100%;
  height: ${spacing('px')};
  background: ${({ theme }) => theme.newUI.dividerColors.default};
  margin: ${spacing('xxl')} 0 ${spacing('xxl')};

  &[data-density='${DENSITY.COMFORTABLE}'] {
    margin: ${spacing('md')} 0 ${spacing('md')};
  }

  &[data-density='${DENSITY.BLOCK}'] {
    margin: 0;
  }
`;

export const $VerticalDivider = styled.div`
  width: ${spacing('px')};
  height: 80%;
  background: ${({ theme }) => theme.newUI.dividerColors.default};
`;
